export default class Tabs {
  constructor() {
    this._wrapper = document.querySelector('.s-tabs_wrapper');

    if (this._wrapper) {
      this.init();
    }
  }

  init() {
    this._tabs = this._wrapper.querySelectorAll('.c-tab');
    this._panels = this._wrapper.querySelectorAll('.c-tab_panel');

    this._tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        this.resetTabs();
        this.activeIndex(index);
      });
    });
  }

  resetTabs() {
    this._tabs.forEach((tab) => {
      tab.classList.remove('active');
    });

    this._panels.forEach((panel) => {
      panel.classList.remove('active');
    });
  }

  activeIndex(index) {
    this._tabs[index].classList.add('active');
    this._panels[index].classList.add('active');
  }
}
